import { parse } from 'qs';

export const getBannerSource = () => {
  const { label } = parse(window.location.search, { ignoreQueryPrefix: true });

  return label;
};
